import TCPill, { TC_PILL_TYPE } from './TCPill';

export default TCPill;
export { TC_PILL_TYPE };
